import {useCallback, useEffect, useState} from 'react';
import {useSelector, useStore} from 'react-redux';
import {useCharityCopy} from '~/common/fabric/CreateDesign/pledge_copy';
import {UPDATE_PLEDGELING_OPTIONS} from '~/common/fabric/reducers/giftingOptions/constants';
import {DonationsModule} from '~/ViewInvitation/routes/Landing/DonationModule/DonationsModule';
import {DonationIcon} from '~library/svg/DonationIcon';
import {OptionWrapper} from './OptionWrapper';

export const Charities = ({
  setShowOverlay,
  shouldShowUpsellModal,
  toggleUpsellModal,
  setToToggleOff,
}) => {
  const store = useStore();
  const {eviteEvent, giftingOptions} = store.getState();
  const charity = useSelector(({giftingOptions: options}) => options.pledgeling_data?.Organization);
  const charityId = charity?.pledgeling_id;
  const eventType = useSelector(({fabricTemplate}) => fabricTemplate?.eventType);
  const charityCopy = useCharityCopy(eventType);

  const onEdit = useCallback(async () => {
    setShowOverlay('charity-donation');
  }, [setShowOverlay]);

  const removeAction = useCallback(() => {
    store.dispatch({
      type: UPDATE_PLEDGELING_OPTIONS,
      // biome-ignore lint/style/useNamingConvention: existing error
      payload: {beneficiary_type: 'Organization'},
    });
  }, [store]);

  const onRemove = useCallback(async () => {
    if (shouldShowUpsellModal()) {
      setToToggleOff('charityDonation');
      toggleUpsellModal();
    } else {
      removeAction();
    }
  }, [removeAction, setToToggleOff, shouldShowUpsellModal, toggleUpsellModal]);

  const [donations, setDonations] = useState([]);
  useEffect(() => {
    if ('pledgeling_beneficiary_type' in giftingOptions.pledgeling_data.Organization) {
      setDonations([
        {
          id: `${eviteEvent.id}_Organization`,
          // biome-ignore lint/style/useNamingConvention: existing error
          donation_url: `https://${window.pledge_url}/widgets/donate/${window.pledge_key}/${eviteEvent.id}_Organization`,
          found: true,
        },
      ]);
    } else {
      setDonations([]);
    }
  }, [eviteEvent?.id, giftingOptions]);

  return (
    <OptionWrapper
      icon={<DonationIcon />}
      title={charityCopy.header}
      subtitle={charityCopy.subHeader}
      onEdit={onEdit}
      isActive={!!charityId}
      onRemove={onRemove}
    >
      <DonationsModule donations={donations} readonly isCreationFlow />
    </OptionWrapper>
  );
};
